import ValidationTestDetailsPage from './validation-test-details-page';

export default ValidationTestDetailsPage;